import { render, staticRenderFns } from "./template.vue?vue&type=template&id=1dad372c&"
import script from "./template.vue?vue&type=script&lang=ts&"
export * from "./template.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports